import React, { useEffect, useRef } from 'react'
import './Controller.scss';
import FirstIdustryContext from '../../contexts/FirstIndustryContext';
import SecondIdustryContext from '../../contexts/SecondIndustryContext';
import Dropdown from '../dropdown/Dropdown';

function Controller(props) {
  let controllerDivRef = useRef();
  let wrap = useRef();


  useEffect(() => {
    function handleResize() {
      document.querySelector('.chart-container__first').style.marginTop = `${wrap.current.clientHeight + 30}px`
    }
    window.addEventListener('resize', handleResize)
    // return _ => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    document.querySelector('.chart-container__first').style.marginTop = `${wrap.current.clientHeight + 30}px`;
  });

  useEffect(() => {
    
    if (props.isMobile) {
      controllerDivRef.current.classList.add('mobile')
    } else {
      controllerDivRef.current.classList.remove('mobile')
    }
    window.addEventListener("scroll", function () {
      let isScrolling;
      var elementTarget = wrap.current;
      if (window.scrollY > (elementTarget.offsetHeight - elementTarget.clientHeight)) {
        window.clearTimeout(isScrolling);

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {
          // Run the callback
          if (!wrap.current.classList.contains('sticky')) {
            wrap.current.classList.add('sticky')
          }
        }, 66);
      } else {
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {
          // Run the callback
          wrap.current.classList.remove('sticky')
        }, 66);
      }
    });
  }, [props])
  return (
    <React.Fragment>
      <div ref={wrap} className="datavis-controller-wrapper">
        <h2 className="datavis-subheading"
          style={props.isMobile ? { fontSize: '1.6em' } : { fontSize: '2.8em' }}
        >Compare expenses between industries:</h2>
        <div className="datavis-controller" ref={controllerDivRef}>
          <div className="datavis-controller__grid1">
            <FirstIdustryContext.Consumer>
              {firstIdustryContext => <Dropdown context={firstIdustryContext} colour="#f5894e" id={1}></Dropdown>
              }
            </FirstIdustryContext.Consumer>
          </div>
          <div>
            <span className='vs'>vs.</span>
          </div>
          <div className="datavis-controller__grid2">
            <SecondIdustryContext.Consumer>
              {secondIdustryContext => <Dropdown context={secondIdustryContext} colour="#f5894e" id={2}></Dropdown>
              }
            </SecondIdustryContext.Consumer>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Controller
